<template>

  <form ref="singUpForm" autocomplete="off" v-on:keydown.enter="signUp">
    <div class="container">

      <!--      <div class="row ">-->
      <!--        <div class="col">-->
      <!--        </div>-->
      <!--        <div class="col-auto">-->
      <!--          <div style="display: block; width: 140px">-->
      <!--            <select v-model="lang" class="form-control" ref="langSelect" @change="reloadLang"-->
      <!--                    :aria-label="$tr('signin.lang-select-hint', 'Select interface language')">-->
      <!--              <option v-for="langCode in langs" :value="langCode">{{ langNames[langCode] }}</option>-->
      <!--            </select>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->

      <div class="row" v-if="hasInvitation">
        <div class="col-12 text-center">
          <div class="alert alert-info mb-0 invitation" v-if="invitation">{{
              $tr('signup.alert-invitation-sign-up', 'You received an invitation from #{1}. ' +
                  'After signing up, organizations will be able to exchange messages.'+
                  'If you already have an account, please log in and accept the invitation.', invitation.companyName)
            }}
          </div>
          <div class="alert alert-info mb-0" style="font-size: 15px;" v-if="!invitation && !invitationError">
            {{ $tr('signup.alert-invitation-info', 'We are checking you invitation...') }}
          </div>
          <div class="alert alert-warning mb-0" style="font-size: 15px;" v-if="invitationError">
            {{ $tr('signup.alert-invitation-warning', 'Your invitation has expired') }}
          </div>
        </div>
      </div>

      <b-row class="">
        <b-col class="text-center">
          <div v-if="azureSignInEnabled" class="mb-1 mt-2 mt-lg-0">
            <button type="button" class="gsi-material-button" @click="signInWithMsBtnClick" style="width: 203px">
              <div class="gsi-material-button-state"></div>
              <div class="gsi-material-button-content-wrapper">
                <div class="gsi-material-button-icon">

              <svg height="28" viewBox="0 0 28 28" width="28" xmlns="http://www.w3.org/2000/svg">
                <title>
                  MS-SymbolLockup</title>
                <rect fill="#f25022" height="9" width="9" x="0" y="0"/>
                <rect fill="#00a4ef" height="9" width="9" x="0" y="10"/>
                <rect fill="#7fba00" height="9" width="9" x="10" y="0"/>
                <rect fill="#ffb900" height="9" width="9" x="10" y="10"/>
              </svg>

                </div>
                <span class="gsi-material-button-contents">Sign up with Microsoft</span>
                <span style="display: none;">Sign up with Microsoft</span>
              </div>
            </button>
          </div>


          <div v-if="googleSignInEnabled && !ssoData" class="mb-3 mt-3">
            <button type="button" class="gsi-material-button" @click="signInWithGoogleBtnClick" style="width: 203px">
              <div class="gsi-material-button-state"></div>
              <div class="gsi-material-button-content-wrapper">
                <div class="gsi-material-button-icon">
                  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"
                       xmlns:xlink="http://www.w3.org/1999/xlink" style="display: block;">
                    <path fill="#EA4335"
                          d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
                    <path fill="#4285F4"
                          d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
                    <path fill="#FBBC05"
                          d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
                    <path fill="#34A853"
                          d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
                    <path fill="none" d="M0 0h48v48H0z"></path>
                  </svg>
                </div>
                <span class="gsi-material-button-contents">Sign up with Google</span>
                <span style="display: none;">Sign up with Google</span>
              </div>
            </button>
          </div>
          <div v-if="!ssoData">
            <h5 class="d-none d-sm-block" style="font-weight: bold">{{ $tr('signup.signup-or', 'or') }}</h5>
            <h5 class="d-none d-sm-block" style="font-weight: bold">
              {{ $tr('signup.signup-email-v2', 'Sign up using email') }}</h5>

            <span class="d-sm-none" style="font-weight: bold">{{
                $tr('signup.signup-or', 'or')
              }} {{ $tr('signup.signup-email-v2', 'Sign up using email') }}</span>
          </div>
          <div v-else>
            <h5 style="font-weight: bold">{{ $tr('signup.tip', 'We are setting up your account now...') }}</h5>
          </div>
        </b-col>
      </b-row>

      <div class="row">
        <div class="col-12">

          <div class="form-group d-none" :style="invitationStyle">
            <label for="organizationNameControl">{{ $tr('signup.region', 'Region') }}</label>
            <div class="input-container">
              <select v-model="selectedRegion" class="form-control" @change="regionChanged">
                <option v-for="region in regions" :key="region.id" :value="region.id">
                  {{ region.name }}
                </option>
              </select>

            </div>
          </div>


          <div class="form-group" :style="invitationStyle">
            <div class="input-container">
              <input
                  type="text"
                  class="form-control"
                  id="loginControl"
                  :readonly="ssoData"
                  autocomplete="username"
                  v-model="form.email"
                  @keyup="checkEmail"
                  @blur="checkEmail"
                  :placeholder="$tr('signup.enter-email','Enter email address')"
                  data-test-path="signin-email"
                  ref="email"
              >
              <b-spinner v-if="emailValidator.validationInProgress" variant="primary" label="Spinning"></b-spinner>
            </div>
            <div class="validator-messages">
              <small v-if="!emailValidator.isValid" class="text-danger"> {{ emailValidator.errorMessage }}</small>
            </div>

          </div>

          <div class="form-group" :style="invitationStyle" v-if="!ssoData">
            <label for="passwordControl">{{ $tr('signup.password', 'Password') }}</label>
            <div class="input-group">
              <input
                  :type="showPassword ? 'text' : 'password'"
                  name="password"
                  class="form-control"
                  id="passwordControl"
                  data-test-path="signup-password"
                  autocomplete="new-password"
                  aria-describedby="password-constraints"
                  v-model="form.password"
                  ref="inputPassword"
                  @keyup="checkPassword"
                  @blur="checkPassword"
                  :placeholder="$tr('signup.enter-password','Enter password')">
              <div class="input-group-append">
                <button class="btn btn-outline-secondary" type="button" @click="togglePasswordVisibility">
                  <font-awesome-icon :icon="showPassword ? 'eye-slash' : 'eye'" />
                </button>
              </div>
            </div>

            <div class="validator-messages">
              <small v-if="!passwordValidator.isValid" class="text-danger">{{ passwordValidator.errorMessage }}</small>
            </div>
          </div>

        </div>
      </div>

      <!-- render recaptcha here-->
      <div class="row mt-3">
        <div class="col-auto" ref="captchaCol" :class="ssoData ? 'd-none' : ''">
          <div :key="'captcha'" id="captchaContainer"></div>
        </div>
      </div>
      <div class="row align-items-center justify-content-end">
        <div class="col"></div>
        <div class="col-auto mt-2">
          <button v-if="!ssoData"
                  type="button"
                  class="btn btn-primary"
                  data-test-path="signin-btn-signup"
                  :disabled="inProgress || (!ssoData && (!emailValidator.isValid || !form.captchaToken))"
                  @click="signUp()">
            {{ $tr('signup.signupv2', 'Get started!') }}
          </button>
        </div>
        <div class="col"></div>
      </div>


      <div class="row">
        <div class="col-12 general-feedback">
          <span v-if="generalFeedback" class="text-danger">{{ generalFeedback }}</span>
        </div>
      </div>

    </div>
  </form>
</template>

<script>
import ApplicationConfig from "@/ApplicationConfig";
import Rpc from "@/Rpc";
import FieldValidator from "@/validation/FieldValidator";
import Client from "@/utils/Client";
import RpcInputValidationException from "@/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException";
import {
  getAutoconfModules,
  getAutoconfTemplate,
  getInviteInfo,
  hasAutoconf,
  hasPendingInvite
} from "@/invitations/invites";
import ModulesConfiguration from "@/server/com/silkplm/model/users/ModulesConfiguration";
import SignUpAutoconf from "@/server/com/silkplm/rpc/dto/SignUpAutoconf";
import {
  getPreselectedPlan,
  isLocalStandalone,
  listRegions,
  postSignup, rememberAutoConf,
  saveLastLoginServer,
  switchRegion
} from "@/components/subscriptions/Subs";
import {googleSignIn, googleSignInEnabled} from "@/components/sso/google";
import signIn from "@/components/SignIn.vue";
import DialogManager from "@/utils/DialogManager";
import {SCOPE_USER} from "@/utils/ConfigManager";
import {azureSignIn, azureSignInEnabled} from "@/components/sso/azure";


export default {
  name: "SignUpForm",

  created() {
    this.emailValidator
        .withOwningComponent(this)
        .withStateGetter(
            () => [this.mode, this.form.email])
        .withLabel($tr("email", "Email"))
        .withValidationFunction(
            () => Rpc.Session.validateRegistrationEmail(this.form.email)
        );
    this.passwordValidator
        .withOwningComponent(this)
        .withStateGetter(
            () => [this.mode, this.form.password])
        .withLabel($tr("password", "Password"))
        .withValidationFunction(
            () => Rpc.Session.validatePassword(this.form.password)
        );
    let that = this;

    window["useAlwaysPassingCaptcha"] = function (val) {
      // console.log("useAlwaysPassingCaptcha:" + val);
      that.alwaysPassingToken = val;
      that.form.captchaToken = val;
    }
  },


  beforeMount() {
    this.captchaKey = ApplicationConfig['CAPTCHA_TOKEN'];
    this.form.email = window.localStorage.getItem('email');
    this.form.organization = window.localStorage.getItem('organization');
  },
  beforeDestroy() {
    // if(this.resetCaptchaScheduleTimer) {
    //   console.log("Captcha timer clera");
    //   clearTimeout(this.resetCaptchaScheduleTimer);
    // }
    this.observer?.disconnect();
  },
  async mounted() {
    this.observePasswordField();
    if (!window['grecaptcha']?.render || !(window['grecaptcha']?.render instanceof Function)) {

      while (!window['grecaptcha']?.render || !(window['grecaptcha']?.render instanceof Function)) {
        await new Promise(r => setTimeout(r, 100));
      }

      window['grecaptcha'].render('captchaContainer', {
        'sitekey': this.captchaKey,
        'callback': '_signup_gc_done',
        'expired-callback': '_signup_gc_expired',
        'error-callback': '_signup_gc_error'
      });

    } else {
      window['grecaptcha'].render('captchaContainer', {
        'sitekey': this.captchaKey,
        'callback': '_signup_gc_done',
        'expired-callback': '_signup_gc_expired',
        'error-callback': '_signup_gc_error'
      });
    }

    // this.resetCaptchaSchedule = () => {
    //   window['grecaptcha'].reset();
    //   this.resetCaptchaScheduleTimer =  setTimeout(this.resetCaptchaSchedule, 25000);
    // }
    // this.resetCaptchaScheduleTimer =  setTimeout(this.resetCaptchaSchedule, 25000);

    await this.setupRegions();

    this.hasInvitation = hasPendingInvite();
    this.hasAutoconf = hasAutoconf();

    getInviteInfo().then(data => {
      this.invitation = data;
      if (!data) {
        this.invitationError = true;
      }
    })
    if (window['_test_captcha_token_'] !== undefined) {
      this.form.captchaToken = window['_test_captcha_token_'];
    }
    this.setSignUp();
    this.focusInput();
  },

  computed: {
    signIn() {
      return signIn
    },
    invitationStyle() {
      return {
        height: this.hasInvitation ? '65px' : '65px'
      }
    },
  },

  methods: {
    observePasswordField() {
      const input = this.$refs.inputPassword;

      const observer = new MutationObserver(() => {
        this.password = input.value;
        this.onPasswordChange();
      });
      this.observer = observer;

      observer.observe(input, {attributes: true, attributeFilter: ["value"], subtree: false, childList: false});

      this.$nextTick(() => {
        if (input.value) {
          this.password = input.value;
          this.onPasswordChange();
        }
      });
    },
    signInWithGoogleBtnClick() {
      googleSignIn();
    },

    signInWithMsBtnClick() {
      azureSignIn();
    },
    async signUpWithGoogleId(ssoData) {
      this.ssoData = ssoData;
      this.form.email = ssoData.email;
      await this.setupRegions();
      //if(this.regions.length === 1){
      await this.signUp();
      //}
    },
    reloadLang(val) {
      if (AppTranslations.selectedLang !== val) {
        AppTranslations.switchLang(this.lang);
      }
    },
    regionChanged() {
      switchRegion(this.selectedRegion);
    },

    async setupRegions() {
      if (this.regions.length) {
        return;
      }
      this.regions = await listRegions();
      let preferredRegion = -1;
      for (let regionIdx in this.regions) {
        let region = this.regions[regionIdx];

        if (region['preferred_for_country']) {
          preferredRegion = regionIdx;
        }
        if (region['preferred_for_continent'] && preferredRegion < 0) {
          preferredRegion = regionIdx;
        }
      }

      if (preferredRegion < 0) {
        preferredRegion = 0;
      }
      this.selectedRegion = this.regions[preferredRegion].id;
      switchRegion(this.regions[preferredRegion].id);
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    focusInput() {
      this.$refs.email?.focus();
    },
    async storeInputsValueByCheckbox() {
      if (this.form.checkboxRememberStatus === true) {
        if (this.form.email) {
          window.localStorage.setItem('email', this.form.email);
        }
        if (this.form.organization) {
          window.localStorage.setItem('organization', this.form.organization);
        }
      } else {
        window.localStorage.removeItem('email');
        window.localStorage.removeItem('organization');
        window.localStorage.removeItem('password');
      }
    },
    async storeInputsValueByCheckboxIfIsCordova() {
      if (this.form.checkboxRememberStatus === true) {
        if (this.form.email) {
          window.localStorage.setItem('email', this.form.email);
        }
        if (this.form.organization) {
          window.localStorage.setItem('organization', this.form.organization);
        }
        if (this.form.password) {
          window.localStorage.setItem('password', this.form.password);
        }
      } else {
        window.localStorage.removeItem('email');
        window.localStorage.removeItem('organization');
        window.localStorage.removeItem('password');
      }
    },
    async signUp() {
      try {
        //if(window.location.href.includes("localhost") || this.hasPreselectedPlan || this.hasInvitation || this.hasAutoconf || window['__signup']){
        this.password = "";
        let userInfo = null;

        Client.lockDuringNextRequest();
        if (this.alwaysPassingToken) {
          this.form.captchaToken = this.alwaysPassingToken;
        }

        if (this.hasAutoconf) {
          let modsConfig = new ModulesConfiguration();
          for (const k of getAutoconfModules()) {
            modsConfig[k] = true;
          }
          let autoConfiguration = new SignUpAutoconf();
          autoConfiguration.modulesConfiguration = modsConfig;
          autoConfiguration.template = getAutoconfTemplate();

          if (this.ssoData) {
            try {
              userInfo = await Rpc.Session.signUpWithAutoconfWithSSO(this.ssoData.token, autoConfiguration);
            } catch (e) {
              Log.fatal("signUpWithAutoconfWithSSO failed: " + this.ssoData.email);
              DialogManager.errorNotification(e);
              this.ssoData = null;
            }
          } else {
            try {
              userInfo = await Rpc.Session.signUpWithAutoconf("",
                  this.form.email,
                  this.form.password,
                  this.form.captchaToken,
                  autoConfiguration);
            } catch (e) {
              let errorMessage = "";
              for (let [fieldName, value] of Object.entries(e.fields)) {
                if (!value.isValid) {
                  errorMessage = value.errorMessage;
                }
              }
              await DialogManager.info(
                  $tr("cantCreateOrganization", "Cannot create an Organization"),
                  errorMessage
              )
            }
          }
        } else {
          let autoConfiguration = new SignUpAutoconf();
          autoConfiguration.modulesConfiguration = null;
          autoConfiguration.template = "default";


          if (this.ssoData) {
            try {
              userInfo = await Rpc.Session.signUpWithAutoconfWithSSO(this.ssoData.token, autoConfiguration);
            } catch (e) {
              Log.fatal("signUpWithAutoconfWithSSOsignUpWithSSO failed: " + this.ssoData.email);
              DialogManager.errorNotification(e);
              this.ssoData = null;
            }
          } else {
            try {
              userInfo = await Rpc.Session.signUpWithAutoconf("", this.form.email, this.form.password, this.form.captchaToken, autoConfiguration);
            } catch (e) {
              let errorMessage = "";
              for (let [fieldName, value] of Object.entries(e.fields)) {
                if (!value.isValid) {
                  errorMessage = value.errorMessage;
                }
              }
              await DialogManager.info(
                  $tr("cantCreateOrganization", "Cannot create an Organization"),
                  errorMessage
              );
            }
          }
        }

        if (!userInfo) {
          throw new Error("user info is empty");
        }
        if (this.hasInvitation) {
          await SessionManager.configManager?.save("tour.autostart.suppliersMarket", "1", SCOPE_USER);
        }

        await rememberAutoConf(userInfo);

        if (!isLocalStandalone() && !this.hasInvitation) {
          if(await postSignup()) {
            return;
          }
        }

        saveLastLoginServer();
        //await SessionManager.installRuntimeCode();

        this.$emit("signupInProgress", userInfo);

        // MOVED TO SignupInProgress
        // if (!window.isCordova){
        //   await this.storeInputsValueByCheckbox(this.form.organization, this.form.email);
        // }else {
        //   await this.storeInputsValueByCheckboxIfIsCordova(this.form.organization, this.form.email, this.form.password);
        // }
        //
        // await SessionManager.preSignIn(true);
        // SessionManager.setUserInfo(userInfo);
        // await SessionManager.postSignIn();

        //reset form
        //this.$refs.singUpForm.reset();

        //window['grecaptcha'].reset();

      } catch (e) {
        window['grecaptcha'].reset();

        if (e instanceof RpcInputValidationException) {

          /** @type {RpcInputValidationException} */
          let validationException = e;


          if (validationException.fields["captcha"] && !validationException.fields["captcha"].isValid) {
            this.generalFeedback = validationException.fields["captcha"].errorMessage.replaceAll("$field", "Captcha");
          }

          this.emailValidator.parseException("email", validationException);
          this.passwordValidator.parseException("password", validationException);
        } else {
          console.error(e);
          this.generalFeedback = $tr('signup.error-server', 'Server error - please try again in few minutes');
        }
      }

    },


    async checkEmail() {
      await this.emailValidator.validateDelayed();
    },
    async checkPassword() {
      await this.passwordValidator.validateDelayed();
    },

    async setSignUp() {
      this.$nextTick(() => {
        window['_signup_gc_done'] = (tokenBase) => {
          this.form.captchaToken = tokenBase;
        }
        window['_signup_gc_expired'] = () => {
          this.form.captchaToken = '';
          window['grecaptcha'].reset();
        }
        window['_signup_gc_error'] = () => {
          window['grecaptcha'].reset();
          this.generalFeedback = $tr('signup.error-captcha', 'Captcha client error - please try again in few seconds')
        }

        this.captchaSetup = true;
      });
    }
  },
  data: () => (
      {
        langs: AppTranslations.langs,
        langNames: AppTranslations.langsNames,
        lang: AppTranslations.selectedLang,

        ssoData: null,
        inProgress: false,
        googleSignInEnabled: googleSignInEnabled(),
        azureSignInEnabled: azureSignInEnabled(),
        selectedRegion: 1,
        regions: [],
        hasInvitation: false,
        hasAutoconf: false,
        invitationError: false,
        hasPreselectedPlan: getPreselectedPlan(),
        passwordError: false,
        invitation: null,
        mode: 'signUp',

        emailValidator: new FieldValidator(),
        passwordValidator: new FieldValidator(),
        captchaKey: "",
        captchaSetup: false,
        generalFeedback: '',
        showPassword: false,
        form: {
          organization: '',
          email: '',
          captchaToken: '',
          password: '',
          password2: ''
        }
      }
  )
}
</script>

<style lang="sass" scoped>

@import '../styles/signin-signup'

#captchaContainer
  margin-top: 15px

.invitation
  font-size: 15px

@media screen and (max-width: 995px)
  .invitation
    font-size: 12px

@media screen and (max-width: 770px)
  .invitation
    font-size: 15px

@media screen and (max-width: 400px)
  .invitation
    font-size: 12px

</style>